"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateDeliveryAddress = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useUpdateDeliveryAddress = function useUpdateDeliveryAddress() {
  var context = _react["default"].useContext(_context.SavedAddressesContext);

  if (!context) {
    throw new Error('useUpdateDeliveryAddress must be used within an SavedAddressesProvider');
  }

  var dispatch = context.dispatch;

  var updateDeliveryAddress = function updateDeliveryAddress(address) {
    dispatch({
      type: _context.SavedAddressesActions.SAVE_DELIVERY,
      payload: address
    });
  };

  var unsetDeliveryAddress = function unsetDeliveryAddress() {
    dispatch({
      type: _context.SavedAddressesActions.SAVE_DELIVERY,
      payload: undefined
    });
  };

  return [updateDeliveryAddress, unsetDeliveryAddress];
};

exports.useUpdateDeliveryAddress = useUpdateDeliveryAddress;